module.exports = __webpack_public_path__ + "static/media/JH_web_1.41d35529.jpg";